import { cn } from '@/lib/utils';
import type { TierUnlockLevel } from '@/lib/tierUnlockBadges';
import { useShowTierUnlockBadge } from '@/hooks/useTierUnlockBadge';

interface TierUnlockBadgeProps {
  unlockTier: TierUnlockLevel | null;
  className?: string;
}

/** Compact "New" badge for nav items and tabs unlocked after a plan upgrade. */
export function TierUnlockBadge({ unlockTier, className }: TierUnlockBadgeProps) {
  const show = useShowTierUnlockBadge(unlockTier);
  if (!show || !unlockTier) return null;

  return (
    <span
      className={cn(
        'shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-none tracking-wide',
        unlockTier === 'enterprise'
          ? 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200'
          : 'bg-primary/15 text-primary',
        'group-data-[collapsible=icon]:absolute group-data-[collapsible=icon]:right-0.5 group-data-[collapsible=icon]:top-0.5 group-data-[collapsible=icon]:h-2 group-data-[collapsible=icon]:w-2 group-data-[collapsible=icon]:p-0 group-data-[collapsible=icon]:text-[0px]',
        className,
      )}
      aria-hidden
    >
      New
    </span>
  );
}
